<!-- Адаптер создания точки заказа к единой модалке точки маршрута -->
<template>
  <RoutePointModal
    resource-type="order"
    :resource-id="orderId"
    :company-id="companyId"
    :existing-points-count="existingPointsCount"
    :show-actual-datetime="false"
    @close="$emit('close')"
    @created="$emit('points-created')"
  />
</template>

<script>
import RoutePointModal from "@/components/RoutePoint/RoutePointModal.vue";

export default {
  name: "AddOrderPointsModal",

  components: {
    RoutePointModal,
  },

  emits: ["close", "points-created"],

  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
    existingPointsCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>
